import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SpinnerService } from 'src/app/shared/components/spinner/spinner.service';
import { UtilsService } from '../../services/general-utils/utils.service';
import { UserService } from '../../services/rest/user.service';
import { CambioPasswordDTO } from '../../models/entities/cambio-password-dto';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AccountService } from '../../services/rest/account.service';

@Component({
  selector: 'password-scaduta-dialog',
  templateUrl: './password-scaduta-dialog.component.html',
  styleUrls: ['./password-scaduta-dialog.component.scss']
})
export class PasswordScadutaDialogComponent implements OnInit, OnDestroy {

  displayModal: boolean;
  subscriptions: Subscription = new Subscription();

  formPassword: FormGroup;

  constructor(
    private spinner: SpinnerService,
    private utilsService: UtilsService,
    private userService: UserService,
    private router: Router,
    private datePipe: DatePipe,
    private accountService: AccountService
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openDialog() {
    this.formPassword = new FormGroup({
      newPassword: new FormControl(null, Validators.required),
      newPasswordConfirm: new FormControl(null, Validators.required)
    });
    this.displayModal = true;
  }

  closeDialog() {
    this.formPassword = null;
    this.displayModal = false;
  }

  newPassword() {
    this.spinner.activate();
    const fp = this.formPassword.value;
    if (fp.newPassword === fp.newPasswordConfirm) {
      let dataScadenzaPassword = new Date();
      dataScadenzaPassword.setFullYear(dataScadenzaPassword.getFullYear() + 1);
      const request: CambioPasswordDTO = {
        newPassword: fp.newPassword,
        dataScadenzaPassword: this.datePipe.transform(dataScadenzaPassword, "yyyyMMdd")
      } 
      this.subscriptions.add(this.userService.changePassword(request).subscribe({
        next: () => {
          this.spinner.deactivate();
          this.closeDialog();
          this.utilsService.fireConfirmationMsg('passwordModificata_msg');
          this.router.navigate(['/homepage']);
        },
        error: error => {
          this.spinner.deactivate();
          this.utilsService.fireErrorConfirmMsg('erroreModificaPassword_msg');
          this.closeDialog();
          throw error;
        }
      }));
    } else {
      this.spinner.deactivate();
      this.utilsService.fireErrorConfirmMsg('passwordNonCoincidono_msg');
    }
  }

  annulla() {
    this.closeDialog();
    this.accountService.logout();
  }

}